"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _utils = require("@/utils");
var _CardDossie = _interopRequireDefault(require("../components/CardDossie"));
var _CardValidaFace = _interopRequireDefault(require("../components/CardValidaFace"));
var _CardValidaFinger = _interopRequireDefault(require("../components/CardValidaFinger"));
var _CardValidaDocuments = _interopRequireDefault(require("../components/CardValidaDocuments"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'CardPersonalData',
  components: {
    CardDossie: _CardDossie.default,
    CardValidaFace: _CardValidaFace.default,
    CardValidaFinger: _CardValidaFinger.default,
    CardValidaDocuments: _CardValidaDocuments.default
  },
  props: {
    itemId: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      process: null,
      personalData: null,
      scoreRisco: {
        value: 0,
        valueAsInt: 0,
        legendTagText: '',
        legendTagBgColor: '#e6e9f0',
        gradientLineColors: {
          radial: false,
          colors: [{
            color: '#fff',
            offset: '0',
            opacity: '1'
          }, {
            color: '#fff',
            offset: '100',
            opacity: '1'
          }]
        }
      },
      abaAtiva: 0,
      insights: {
        cpf: [],
        docs: [],
        celular: [],
        face: [],
        cep: [],
        email: []
      },
      imgDiamondAsBase64string: require('@/assets/images/onboarding/diamante-risco.png')
    };
  },
  computed: {
    stepActiveProcess: function stepActiveProcess() {
      var _this$process;
      var step = ((_this$process = this.process) === null || _this$process === void 0 ? void 0 : _this$process.step) || 1;
      if (step === 8) return 5;
      return step - 1;
    },
    birthday: function birthday() {
      var _convertDateBirthBR, _this$personalData;
      return (_convertDateBirthBR = (0, _utils.convertDateBirthBR)((_this$personalData = this.personalData) === null || _this$personalData === void 0 ? void 0 : _this$personalData.birthdate)) !== null && _convertDateBirthBR !== void 0 ? _convertDateBirthBR : '';
    },
    zipCode: function zipCode() {
      var _this$personalData$zi, _this$personalData2;
      var cep = (_this$personalData$zi = (_this$personalData2 = this.personalData) === null || _this$personalData2 === void 0 ? void 0 : _this$personalData2.zipCode) !== null && _this$personalData$zi !== void 0 ? _this$personalData$zi : '';
      return cep.slice(0, 2) + '.' + cep.slice(2, 5) + '-' + cep.slice(5);
    },
    phone: function phone() {
      var _this$personalData$ph, _this$personalData3;
      var fone = (_this$personalData$ph = (_this$personalData3 = this.personalData) === null || _this$personalData3 === void 0 ? void 0 : _this$personalData3.phone) !== null && _this$personalData$ph !== void 0 ? _this$personalData$ph : '';
      return "(".concat(fone.slice(0, 2), ") ").concat(fone.slice(2));
    },
    cpf: function cpf() {
      var _this$personalData$do, _this$personalData4;
      var doc = (_this$personalData$do = (_this$personalData4 = this.personalData) === null || _this$personalData4 === void 0 ? void 0 : _this$personalData4.document) !== null && _this$personalData$do !== void 0 ? _this$personalData$do : '';
      return doc.replace(/[^\d]/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
  },
  mounted: function mounted() {
    this.getDetails();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchOnboardingDataPerson'])), {}, {
    getDetails: function () {
      var _getDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$this$fetchOnbo, data, _data$validaScore, links, score, tags, colorFrom, colorTo;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.fetchOnboardingDataPerson(this.itemId);
            case 1:
              _yield$this$fetchOnbo = _context.v;
              data = _yield$this$fetchOnbo.data;
              if (data) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              this.process = data.process;
              this.personalData = data.person;
              _data$validaScore = data.validaScore, links = _data$validaScore.LINKS, score = _data$validaScore.SCORE, tags = _data$validaScore.TAGS;
              if (tags) this.setRiskData(tags);
              if (links) this.drawDiamond(links);
              if (score) {
                this.scoreRisco.value = parseFloat(score);
                this.scoreRisco.valueAsInt = parseInt(this.scoreRisco.value);
                colorFrom = '';
                colorTo = '';
                if (this.scoreRisco.value <= 25) {
                  // neutro
                  colorTo = '#B30101';
                  colorFrom = '#FF0101';
                  this.scoreRisco.legendTagBgColor = colorTo;
                  this.scoreRisco.legendTagText = 'ALTO RISCO';
                } else if (this.scoreRisco.value <= 50) {
                  // fraco
                  colorTo = '#B35900';
                  colorFrom = '#FF7F00';
                  this.scoreRisco.legendTagBgColor = colorTo;
                  this.scoreRisco.legendTagText = 'RISCO';
                } else if (this.scoreRisco.value <= 75) {
                  // médio
                  colorTo = '#D9A91A';
                  colorFrom = '#FFC71F';
                  this.scoreRisco.legendTagBgColor = colorTo;
                  this.scoreRisco.legendTagText = 'RISCO BAIXO';
                } else {
                  // forte
                  colorTo = '#0E812B';
                  colorFrom = '#14B83D';
                  this.scoreRisco.legendTagBgColor = colorTo;
                  this.scoreRisco.legendTagText = 'SEM RISCO';
                }
                this.scoreRisco.gradientLineColors.colors[0].color = colorFrom;
                this.scoreRisco.gradientLineColors.colors[1].color = colorTo;
              }
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getDetails() {
        return _getDetails.apply(this, arguments);
      }
      return getDetails;
    }(),
    setRiskData: function setRiskData(arrTags) {
      var _this = this;
      arrTags.forEach(function (tag) {
        var arrDimensions = tag.grouper.replace('Telefone', 'Celular').split(' ');
        arrDimensions.forEach(function (dimension) {
          return _this.insights[dimension.toLowerCase()].push(tag);
        });
      });
    },
    getSrcImgByDimensao: function getSrcImgByDimensao(from, to) {
      var jsonData = this.insights[from.toLowerCase()];
      var status = jsonData.find(function (x) {
        return x.vinculo.toLowerCase() === to.toLowerCase();
      }).status;
      return require('@/assets/images/onboarding/' + from.toLowerCase() + '_' + to.toLowerCase() + '_' + status + '.png');
    },
    getSrcImgStatus: function getSrcImgStatus(status) {
      return require('@/assets/images/onboarding/bullet-status-' + status.toLowerCase() + '.png');
    },
    drawDiamond: function drawDiamond(links) {
      var canvas = document.getElementById('diamond-canvas');
      var colors = {
        neutro: '#ff0000',
        fraco: '#ff7f00',
        medio: '#ffc71f',
        forte: '#14b83d'
      };
      var verticeCpf = {
        x: 168,
        y: 45
      };
      var verticeDocs = {
        x: 292,
        y: 117
      };
      var verticeCelular = {
        x: 292,
        y: 258
      };
      var verticeFace = {
        x: 168,
        y: 330
      };
      var verticeCep = {
        x: 45,
        y: 258
      };
      var verticeEmail = {
        x: 45,
        y: 117
      };
      var setLinkLine = function setLinkLine(context, serverInfo) {
        var _serverInfo$nome$spli = serverInfo.nome.split('_'),
          _serverInfo$nome$spli2 = _slicedToArray(_serverInfo$nome$spli, 2),
          from = _serverInfo$nome$spli2[0],
          to = _serverInfo$nome$spli2[1]; // Example: 'DOCUMENT_ZIPCODE'
        switch (from) {
          case 'DNI':
            from = verticeCpf;
            break;
          case 'FACE':
            from = verticeFace;
            break;
          case 'ZIPCODE':
            from = verticeCep;
            break;
          case 'EMAIL':
            from = verticeEmail;
            break;
          case 'PHONE':
            from = verticeCelular;
            break;
          case 'DOCUMENTS':
            from = verticeDocs;
            break;
        }
        switch (to) {
          case 'DNI':
            to = verticeCpf;
            break;
          case 'FACE':
            to = verticeFace;
            break;
          case 'ZIPCODE':
            to = verticeCep;
            break;
          case 'EMAIL':
            to = verticeEmail;
            break;
          case 'PHONE':
            to = verticeCelular;
            break;
          case 'DOCUMENTS':
            to = verticeDocs;
            break;
        }
        var color = '';
        switch (serverInfo.valor) {
          case '0':
            color = 'neutro';
            break;
          case '1':
            color = 'fraco';
            break;
          case '2':
            color = 'medio';
            break;
          case '3':
            color = 'forte';
            break;
        }
        context.beginPath();
        context.moveTo(from.x, from.y);
        context.lineTo(to.x, to.y);
        context.lineWidth = 2;
        context.strokeStyle = colors[color];
        context.stroke();
      };
      var arrLinks = [];
      for (var _i = 0, _Object$entries = Object.entries(links); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        arrLinks.push({
          'valor': value,
          'nome': key
        });
      }
      var context = canvas.getContext('2d');
      arrLinks.forEach(function (item) {
        return setLinkLine(context, item);
      });
    },
    relevanceFilterHandler: function relevanceFilterHandler(value, row) {
      return row['relevance'].includes(value);
    }
  })
};